import { postfixNumber } from "../utils";

interface Props {
  number: number;
}

const PostfixNumber = ({ number }: Props) => <>{postfixNumber(number)}</>;

export default PostfixNumber;
